module.exports = __webpack_public_path__ + "img/LOGO白背景.dcbd069a.png";